import React from "react";

/**
 * About component that provides information about the Sadima project in both Swedish and English.
 * 
 * @returns {JSX.Element} The rendered about page with project details.
 */
export function About() {
  return (
    <div className="about-container">
      <div className="light-text">
        <h3>
          Välkommen till Sadima, språkstöd till mödrahälsovård!
        </h3>
        <p>
          Denna webbsida har skapats som ett dialogstöd åt svenska barnmorskor
          som behöver samtala med kvinnor som har begränsade kunskaper i
          svenska. Stödet finns på tre språk – arabiska, engelska och svenska.
          Stödet är ett komplement till en tolk.
        </p>
        <p>
          Syftet är att ge rätt information till rätt person vid rätt tidpunkt.
          Sadima innehåller enbart evidensbaserad och kvalitetssäkrad
          information och har utvecklats i samarbete mellan med forskare vid
          Linnéuniversitetet och barnmorskor som arbetar i mödravården i region
          Kalmar län.
        </p>
        <p>
          {" "}
          Projektet har finansierats av Vinnova och Familjen Kamprads stiftelse.{" "}
        </p>
        <p>Klicka i menyn uppe till höger för att byta språk.</p>
        <p>
          Klicka{" "}
          <a href="https://lnu.se/forskning/sok-forskning/forskningsprojekt/projekt-vanta-barn-pa-arabiska-och-svenska-effektiv-och-integrerande-design-for-interaktiv-modrahalsovard/">
            här
          </a>{" "}
          för mer information
        </p>
      </div>
      <div className="light-text">
        <h3>
          Welcome to Sadima, language support in antenatal care!
        </h3>
        <p>
          This website was created to assist Swedish midwives in antenatal care
          when they need to communicate with women who have a limited knowledge
          of Swedish. There are three languages – Arabic, English, and Swedish.
          Sadima serves as a complement to an interpreter.
        </p>
        <p>
          The aim is to give the right information to the right person at the
          right time. Sadima contains only evidence-based, quality-assured
          information and was developed in collaboration between researchers at
          Linnaeus University and midwives who work in antenatal care, in Kalmar
          County, Sweden.
        </p>
        <p>
          The project was funded by Vinnova and the Kamprad Family Foundation.
        </p>
        <p>Click in the menu in the top right to change language.</p>
        <p>
          Click{" "}
          <a href="https://lnu.se/forskning/sok-forskning/forskningsprojekt/projekt-vanta-barn-pa-arabiska-och-svenska-effektiv-och-integrerande-design-for-interaktiv-modrahalsovard/">
            {" "}
            here{" "}
          </a>
          for more information{" "}
        </p>
      </div>
    </div>
  );
}
